import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
export default (onSuccess, onError) => {
    const [mutation, { data, error, loading }] = useMutation(
    gql`mutation deleteUniversity($universityId: ID!){
        deleteUniversity(universityId: $universityId) 
        }`
    )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    mutation(obj).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.deleteUniversity : null, error, validationErrors, submit }
}
